import manifest from './manifest';

export { default as OwnerReportingApp } from './pages/OwnerReportingApp';
export { default as OwnerReportsPage } from './pages/OwnerReports';

/**
 * Frontend plugin entry — registers pages + slot components via Host UI API.
 */
export function register(app) {
  app.useManifest(manifest);
  app.registerPage('dashboard', () => import('./pages/Dashboard'));
  app.registerPage('calendar', () => import('./pages/Calendar'));
  app.registerPage('service-packages', () => import('./pages/ServicePackages'));
  app.registerPage('unit-config', () => import('./pages/UnitConfig'));
  app.registerPage('revenue', () => import('./pages/Revenue'));
  app.registerPage('expenses', () => import('./pages/Expenses'));
  app.registerPage('installments', () => import('./pages/Installments'));
  app.registerPage('reporting', () => import('./pages/Reporting'));
  app.registerPage('settings', () => import('./pages/Settings'));
  app.registerPage('owner-reports', () => import('./pages/OwnerReports'));
  app.registerSlotComponent('OwnerReportingUnitSettings', () => import('./slots/UnitSettings'));
}

export { manifest };
export const code = 'owner-reporting';
